import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import { Typography } from "@mui/material";
import { memo } from "react";
import { IconButton } from "../IconButtonNew/IconButton.js";
import { StyledDialogTitle, StyledDialogContent, StyledDialogActions } from "./styles.js";
import { Nowrap } from "../Nowrap.js";
import { CloseIcon } from "../../icons/24/Action/Close.js";
import { spreadSx } from "../../utils/spreadSx.js";
import { inheritDataTestId } from "../../utils/dataTestId.js";
const DialogTitle = memo(
  ({
    onClose,
    children,
    className,
    noContent,
    sx,
    ...props
  }) => /* @__PURE__ */ jsx(StyledDialogTitle, { className, sx, component: "div", children: noContent ? children : /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(DialogTitleText, { children }),
    /* @__PURE__ */ jsx(
      IconButton,
      {
        onClick: onClose,
        color: "quaternary",
        size: "lg",
        "data-test-id": inheritDataTestId(props, "close-btn"),
        children: /* @__PURE__ */ jsx(CloseIcon, {})
      }
    )
  ] }) })
), DialogTitleText = ({ children, sx }) => /* @__PURE__ */ jsx(
  Typography,
  {
    variant: "18_24_700",
    component: "h2",
    sx: [
      {
        minWidth: 200,
        color: (t) => t.palette.text.primary,
        "*": { color: "inherit" }
      },
      ...spreadSx(sx)
    ],
    children: /* @__PURE__ */ jsx(Nowrap, { children })
  }
);
DialogTitle.displayName = "DialogTitle";
const DialogContent = StyledDialogContent, DialogActions = StyledDialogActions;
export {
  DialogActions,
  DialogContent,
  DialogTitle,
  DialogTitleText
};
//# sourceMappingURL=Dialog.js.map
